"use client";

import React from 'react';

export default function CallButton({ className = "", children,location = "unknown" }) {
  const projectCode = "emsys.solutions90"; 
  const phoneNumber = "9011060932";

  const handleCallTracking = async () => {
    try {
      await fetch('https://clients.dotphi.com/seo_html/call_log.php', { 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          project_unique_code: projectCode,
          phone_number: phoneNumber,
           location: location,
        }),
      });
    } catch (error) {
      console.error('Tracking failed:', error);
    }
  };

  return (
    <a 
      href={`tel:+91${phoneNumber}`} 
      onClick={handleCallTracking}
      className={className}
    >
      {children}
    </a>
  );
}